var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count === 50)?_c('span',{staticClass:"events-info pull-right"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"fa fa-warning",attrs:{"aria-hidden":"true","title":_vm.n__(
      'Limited to showing %d event at most',
      'Limited to showing %d events at most',
      50
    ),"data-placement":"top"}}),_vm._v("\n  "+_vm._s(_vm.n__('Showing %d event', 'Showing %d events', 50))+"\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3243e6e8","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/limit_warning_component.vue
// module id = null
// module chunks = 